import React from 'react';
import { sumMapsAcrossDays } from './aggregations';

const ORDER = ['critical', 'high', 'medium', 'info'];
const COLORS = { critical: '#dc2626', high: '#f97316', medium: '#eab308', info: '#9ca3af' };
const LABELS = { critical: 'Critical', high: 'High', medium: 'Medium', info: 'Info' };

export default function SeverityBreakdown({ dailyDocs = [] }) {
    const agg = sumMapsAcrossDays(dailyDocs, 'by_red_flag_severity');
    const total = ORDER.reduce((acc, k) => acc + (agg[k] || 0), 0);
    if (!total) {
        return (
            <section className="dashboard-section">
                <h3>Severity breakdown (30d, all firings)</h3>
                <p className="dashboard-empty">No flag firings in the last 30 days.</p>
            </section>
        );
    }
    return (
        <section className="dashboard-section">
            <h3>Severity breakdown (30d, all firings)</h3>
            <div className="severity-bar">
                {ORDER.map((k) => {
                    const n = agg[k] || 0;
                    if (!n) return null;
                    return (
                        <div
                            key={k}
                            className="severity-segment"
                            title={`${LABELS[k]}: ${n}`}
                            style={{ width: `${(n / total) * 100}%`, background: COLORS[k] }}
                        />
                    );
                })}
            </div>
            <div className="severity-legend">
                {ORDER.map((k) => (
                    <span key={k}>
                        <strong style={{ color: COLORS[k] }}>{LABELS[k]}</strong> {agg[k] || 0}
                    </span>
                ))}
            </div>
        </section>
    );
}
